import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import { Box, CircularProgress } from "@mui/material";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      const destination = location.pathname + location.search;
      const searchParams = new URLSearchParams(location.search);
      const appSlug = searchParams.get('app');

      let loginUrl = "/login";
      if (appSlug) {
        loginUrl += `?app=${encodeURIComponent(appSlug)}`;
      } else if (destination !== '/login') {
        loginUrl += `?redirect=${encodeURIComponent(destination)}`;
      }

      navigate(loginUrl, { replace: true });
    }
  }, [isAuthenticated, navigate, location.pathname, location.search]);

  if (!isAuthenticated) {
    return (
      <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
